import React from 'react';
import PropTypes from "prop-types";
import { useTheme, css } from "@emotion/react";
import {ButtonPill} from "@/base";

const linkContainerStyles = css(`
        display: flex; 
        justify-content: center;
        align-items: center;
        height: 8em;
    `);

const LinkWidget = ({content}) => {
    const theme = useTheme();
    const fontTheme = theme.header.fontFamily;

    return <div css={linkContainerStyles}>{content.link.map((index) => (
        <div key={index}>
            <ButtonPill buttonTheme={'dark'} to={index.link_url} style={{fontFamily: fontTheme, cursor: 'pointer', textDecoration: 'none', color: "#448DA4"}}>{index.page_link}</ButtonPill>
        </div>
        ))}
    </div>
}

LinkWidget.propTypes = {
    content: PropTypes.object
};

export default LinkWidget;